export default "__VITE_ASSET__CGY3K2yP__"